type RefreshRecord = {
  uris?: string;
  addeddUri?: string;
};

type RefreshSongVersion = {
  uri?: string;
  date?: string;
  orginalDate?: string;
};

type RefreshVersion = {
  version?: number;
  uris?: RefreshSongVersion[];
};

const parseJsonArray = <T>(value: unknown): T[] => {
  if (typeof value !== 'string' || !value.trim()) {
    return [];
  }

  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const resolveOriginalDateFromRefreshRecord = (
  playlistRefreshRecord: RefreshRecord[] | undefined,
  trackUri: string | undefined,
  fallbackDate?: string
) => {
  if (!trackUri || !playlistRefreshRecord?.length) {
    return fallbackDate;
  }

  const latestRecord = playlistRefreshRecord[0];
  const versions = parseJsonArray<RefreshVersion>(latestRecord?.uris);
  const latestVersion = versions[versions.length - 1];
  const versionMatch = latestVersion?.uris?.find(song => song?.uri === trackUri);

  if (versionMatch?.orginalDate) {
    return versionMatch.orginalDate;
  }

  if (versionMatch?.date) {
    return versionMatch.date;
  }

  const addedUriRecords = parseJsonArray<RefreshSongVersion>(latestRecord?.addeddUri);
  const addedUriMatch = addedUriRecords.find(song => song?.uri === trackUri);

  return addedUriMatch?.date || fallbackDate;
};
